import { Directive, Input, OnInit, inject } from '@angular/core';
import { IrisGridMode } from '@iris/common/modules/grid/ag-grid/models/iris-grid-mode';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';

@Directive({
  selector: `ag-grid-angular[irisGridMode]`,
  standalone: false,
})
export class AgGridFixServerSortingDirective implements OnInit {
  private readonly agGrid = inject(AgGridAngular);

  @Input('irisGridMode') gridMode: IrisGridMode;

  ngOnInit(): void {
    if (this.gridMode === 'CLIENT') return;

    if (this.agGrid.defaultColDef) {
      this._setComparator(this.agGrid.defaultColDef);
    }
    else if (this.agGrid.gridOptions) {
      this.agGrid.gridOptions.defaultColDef ||= {};
      this._setComparator(this.agGrid.gridOptions.defaultColDef);
    }
  }

  _setComparator(colDef: ColDef): void {
    colDef.comparator = () => 0;
  }
}
